import { StyleSheet } from 'react-native';
import {
  darkestGrey,
  grey,
  fontFamilyLight,
  italic,
  fontSizeMedium,
} from '../../constants/palette';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    margin: 20,
  },
  genreList: {
    marginBottom: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  activeButtonStyle: {
    alignItems: 'center',
    minWidth: 20,
    margin: 3,
    marginVertical: 3,
  },
  inactiveButtonStyle: {
    alignItems: 'center',
    minWidth: 20,
    margin: 3,
    marginVertical: 3,
    backgroundColor: darkestGrey,
  },
  // TODO: REMOVE AFTER PRIVATE BETA: https://app.shortcut.com/tone-birds/story/471/remove-genre-restriction-for-fans-after-private-beta
  privateBetaText: {
    textAlign: 'center',
    marginBottom: 20,
    color: grey,
    fontFamily: fontFamilyLight,
    fontSize: fontSizeMedium,
    fontStyle: italic,
  },
});

export default styles;
